<template>
  <div class="page">
    <el-form :inline="true" ref="form" label-width="100px">
		<div style="display: flex">
			<el-form-item>
			  <el-checkbox-group v-model="enabled">
				<el-checkbox :label="1">启用中</el-checkbox>
				<el-checkbox :label="0">停用中</el-checkbox>
			  </el-checkbox-group>				  
			</el-form-item>
			<el-form-item style="margin-left: 30px;">		
			  <el-checkbox-group v-model="focused">
				<el-checkbox :label="1">已关注</el-checkbox>
				<el-checkbox :label="0">未关注</el-checkbox>
			  </el-checkbox-group>	  
			</el-form-item>		
			<el-form-item style="margin-left: 50px; margin-right: 50px;">
				<label style="color: orange;">关注报价后，如果价格发生变化，你会收到消息提醒（需要关注发货助手公众号）</label>
			</el-form-item>		
			<el-popover placement="right" :width="'176'" trigger="click" v-if="$qiniu != null && salesMan != null">
				<div v-if="salesMan.wechatQRCode != ''">
					<img :src="$qiniu.domain + salesMan.wechatQRCode" style="width: 150px;height: 150px;display: block;">
					<span style="display: block;color: teal;width: 150px;text-align: center;">微信联系：{{salesMan.userName}}</span>
					<span style="display: block;color: teal;width: 150px;text-align: center;">{{salesMan.contacts}}</span>
				</div>
				<div style="height: 30px; cursor: pointer;" slot="reference" v-if="salesMan != null">
					<font-awesome-icon :icon="['fab', 'weixin']" style="margin-right: 12px;color: rgb(42,161,69);font-size: 22px;" />
					<span style="color: rgb(42,161,69);font-size: 16px;font-weight: bold;">{{'业务:' + salesMan.userName}}</span>
				</div>									
			</el-popover>					
		</div>
		<div style="display: flex;">
			<el-form-item label="服务商">
				<el-cascader v-model="spIdDepartName" :options="providerOptions" :props="{ checkStrictly: true, expandTrigger: 'hover' }"></el-cascader>
			</el-form-item>
			<el-form-item label="渠道名">
				<el-input v-model="sea" placeholder="搜索渠道名"></el-input>
			</el-form-item>
			<el-form-item>
				<el-radio-group v-model="queryBillType">
				  <el-radio-button label="">全部</el-radio-button>
				  <el-radio-button v-for="(item, key) in queryBillTypeList" :label="item || '专线'" :key="key">{{item || '专线'}}</el-radio-button>
				</el-radio-group>
			</el-form-item>
			<el-form-item style="margin-right: 50px;">
				<el-button type="primary" icon="el-icon-refresh" @click="goquotedetailslist(false)">批量打开</el-button>
				<el-button type="primary" icon="el-icon-download" @click="goquotedetailslist(true)">批量下载</el-button>
			</el-form-item>
		</div>
    </el-form>
    <auto-table-data ref="table" id='quoted' :loading="loading" :columns='columns' :data='acceptData' :columns-hand='paraphrase' style="flex: 1;display: flex;flex-direction: column;overflow: hidden;">
      <template #providerName="{row}">
         <span>{{row.providerDepartName?row.providerDepartName:row.providerName}}</span>
      </template>
	  <template #providerQuoteName="{row}">
        <span @click="goquotedetails(row)" style="color: rgb(42,161,69);">{{row.providerQuoteName}}</span>
        <template v-if="userinfo.wechatUsers && userinfo.wechatUsers.length">
          <el-tag :effect="row.focused?'dark':'plain'" :type="row.focused?'':'info'" @click="consignorquotefocus(row)" style="float: right;margin-top: 8px;cursor: pointer;">{{row.focused?'已关注':'关注'}}</el-tag>
        </template>
        <el-tag :effect="row.focused?'dark':'plain'" v-else @click="dialogTableVisible = true" :type="row.focused?'':'info'" style="float: right;margin-top: 8px;cursor: pointer;">{{row.focused?'已关注':'关注'}}</el-tag>
      </template>
      <template #providerQuoteStatus="{row}">
        <label :class="row.providerQuoteStatus?'':'red'">{{row.providerQuoteStatus?'启用':'停用'}}</label>
      </template>
      <template #recentPickupMinutes="{row}">
        <template v-if="row.recentPickupMinutes>0">
          <template v-if='row.recentPickupMinutes/60/24<0.8'>当天提取</template>
          <template v-else-if='row.recentPickupMinutes/60/24<2'>次日提取</template>
          <template v-else>{{parseInt(row.recentPickupMinutes/60/24)}}-{{parseInt(row.recentPickupMinutes/60/24)+1}}天提取</template>
        </template>
      </template>
      <template #lastUpdateTime="{row}">
        <label :class="timeflog(row.lastUpdateTime)?'red':''">{{row.lastUpdateTime}}</label>
      </template>
      <template #lastUpdateContent="{row}">
        <el-popover placement="left" width="600" trigger="click">
          <label slot="reference" @click="quotelogquoteCode(row)" class="blue">{{row.lastUpdateContent||'...'}}</label>
          <div v-if="log.length" style="height: 300px;overflow: auto;">
            <div v-for="(item, i) in log" :key="i">
              <span style="display: inline-block;width: 200px;">{{item.lastUpdateTime}}</span>
              <span>{{item.lastCustomerContent}}</span>
            </div>
          </div>
          <span v-else>加载中...</span>
        </el-popover>
      </template>
    </auto-table-data>
    <el-dialog :visible.sync="dialogTableVisible" width='290px'>
      <span slot="title" style="color:red;">需要先关注公众号才能关注报价，微信实时接收报价更新信息</span>
      <el-image class="container" :src="require('@/assets/img/shipping.png')" fit="contain" style="width: 250px;height: 250px;display: block;" />
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { page } from '@/mixins/page'
export default {
	mixins: [page],
	data() {
		return {
			// form
			queryBillType: '',
			focused: [],
			enabled: [],
			sea: '',
			providerOptions: [],
			spIdDepartName: [],	
			salesMan: null,
			// table
			columns: [
				{ field: 'providerName', title: '服务商', width: 90, slots: { default: 'providerName'} },
				{ field: 'bizType', title: '业务类型', width: 160 },
				{ field: 'providerQuoteName', title: '报价名', width: 260, slots: { default: 'providerQuoteName'} },
				{ field: 'providerQuoteStatus', title: '状态', width: 100, slots: { default: 'providerQuoteStatus'} },
				{ field: 'recentPickupMinutes', title: '渠道时效', width: 160, slots: { default: 'recentPickupMinutes'} },
				{ field: 'lastUpdateTime', title: '更新时间', width: 160, slots: { default: 'lastUpdateTime'} },
				{ field: 'lastUpdateContent', title: '更新内容', slots: { default: 'lastUpdateContent'} },
			],
			loading: false,
			allData: [],
			userinfo: JSON.parse(localStorage.getItem('userinfo')),
			dialogTableVisible: false,
			log: [],
		}
	},
	computed: {
		queryBillTypeList() {
			let list = this.allData.reduce((arr, crr) => arr.add(crr.queryBillType), new Set())
			return list
		},
		acceptData() {
			return this.allData
				.filter((item) => {
					if(this.spIdDepartName.length == 0) return true
					if((this.spIdDepartName.length == 1) && (this.spIdDepartName[0] == item.providerCode)) return true
					if((this.spIdDepartName.length > 1) && (this.spIdDepartName[0] == item.providerCode) 
							&& (this.spIdDepartName[1] == item.providerDepartName)) return true
					return false
				})
				.filter((item) => {
					// 渠道类型
					if (!this.queryBillType) return true
					if (this.queryBillType == '专线' && !item.queryBillType) return true
					return this.queryBillType == item.queryBillType
				})
				.filter((item) => {
					// 关注
					if (!this.focused.length || this.focused.length == 2) return true
					return this.focused[0] == item.focused
				})
				.filter((item) => {
					if (!this.enabled.length || this.enabled.length == 2) return true
					return this.enabled[0] == item.providerQuoteStatus
				})
				.filter((item) => {
					// 搜索
					if (!this.sea) return true
					if (item.providerQuoteName.indexOf(this.sea) > -1) return true
				})
		},
	},
	async mounted() {
		Vue.prototype.$qiniu = await this.$api.uploadtoken() // 刷新七牛token有效期
		let branchList = JSON.parse(localStorage.getItem('branchlist'))
		for(let i = 0, len = branchList.length; i < len; i++){		
			let option = {
				value: branchList[i].branchCode,
				label: branchList[i].branchName,
			}
			if(branchList[i].branchCode == '85689'){
				//LHD特殊处理
				let setting = await this.$api.getDepartmentSetting('85689')
				if(setting && setting.value){
					let departArr = setting.value.split(",")
					option.children = []
					departArr.forEach((departName)=>{
						let childOption = {
							value: departName,
							label: departName
						}
						option.children.push(childOption);
					})
				}
			}
			this.providerOptions.push(option)
		}
		if(this.providerOptions.length > 0){
			this.spIdDepartName = [this.providerOptions[0].value]
			this.spId = this.providerOptions[0].value
			this.salesMan = await this.$api.getProviderSalesMan(localStorage.getItem('tenantId'), this.spId)
		}		
		this.getTable()
	},
	methods: {
		// 表格查询
		async getTable() {
			this.loading = true
			this.allData = await this.$api.consignorquote()
			this.loading = false
		},
		// 时间
		timeflog(lastUpdateTime) {
			return (new Date().getTime() - new Date(lastUpdateTime).getTime()) / 1000 / 60 / 60 < 24
		},
		// 关注
		async consignorquotefocus(row) {
			row.focused = row.focused ? 0 : 1
			let data = {
				...row,
				...this.userinfo,
			}
			await this.$api.consignorquotefocus(row.focused, data)
			this.$message.success(row.focused ? '关注成功' : '已取消关注')
		},
		// 报价日志
		async quotelogquoteCode(row) {
			this.log = []
			this.log = await this.$api.quotelogquoteCode(row.providerQuoteCode)
			console.log(this.log)
			if(this.log.length > 0){
				for(let l of this.log){
					if(l.lastUpdateContent.startsWith('系统 燃油涨:')){
						l.lastUpdateContent = ''
					}
				}
			}
		},
		// 报价明细
		async goquotedetails(row) {
			this.$router.push({ name: 'QuotedDetails', params: { list: [row] } })
		},
		// 报价明细
		async goquotedetailslist(flog) {
			let selectRecords = this.$refs.table.$refs.autoTable.getCheckboxRecords()
			if(selectRecords.length>50)return this.$message.warning('最多选中50条数据')
			if (selectRecords.length) {
				this.$router.push({ name: 'QuotedDetails', params: { list: selectRecords, down: flog } })
			}
		},
		// 导出字段转义
		paraphrase(row, template) {
			if (template == 'providerQuoteName') {
				return row.providerQuoteName || ''
			}
			if (template == 'providerQuoteStatus') {
				return row.providerQuoteStatus?'启用':'停用' || ''
			}
			if (template == 'recentPickupMinutes') {
				if(row.recentPickupMinutes>0){
					return row.recentPickupMinutes/60/24<0.8?'当天提取':row.recentPickupMinutes/60/24<2?'次日提取':parseInt(row.recentPickupMinutes/60/24)+'-'+(parseInt(row.recentPickupMinutes/60/24)+1)+'天提取' || ''
				}
				return ''
			}
			if (template == 'lastUpdateTime') {
				return row.lastUpdateTime || ''
			}
			if (template == 'lastUpdateContent') {
				return row.lastUpdateContent || ''
			}
		},
	},
}
</script>

<style scoped>
</style>